const apiKey = 'Tv-Qghle6Y58QT-j0LuUWXGmfn2WxXiFO3bNkOTFzBCWD1cJDqO3dr8v5vcc1cqTHf2pk7CI0FqNI7vncH15edoXnOhZhh4wRbFQfM7qphUvQzyftzv3lvxEunDtXXYx';

let Yelp = {
    search (term, location, sortBy) {
        return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`, {
            headers: {
                Authorization : `Bearer ${apiKey}`,
            }
        }).then(response => {
            return response.json();
        }).then(jsonResponse => {
            if (jsonResponse.businesses) {
                return jsonResponse.businesses.map(business => {
                    return {
                        id : business.id,
                        imageSrc : business.image_url,
                        name: business.name,
                        address: business.location.address1,
                        city: business.location.city,
                        state: business.location.state,
                        zipCode: business.location.zip_code,
                        category: business.categories[0].title,
                        rating: business.rating,
                        reviewCount: business.review_count,
                    }
                });
            }
        })
    }
};

export default Yelp;